import { Pencil, Trash2 } from 'lucide-react'
import type { BasketItem, DictionaryIngredient } from '@entities/calculator'
import {
  formatAmount,
  formatRub,
  parseDecimal,
  quantShort,
  toKopecks,
  unitPrice,
} from '@entities/calculator'

interface ProductRowProps {
  item: BasketItem
  /**
   * Ингредиент из справочника. `undefined` — его оттуда убрали: строку всё
   * равно показываем, иначе цену не поправить и позицию не удалить, а в расчёте
   * рецепта она продолжает участвовать.
   */
  ingredient: DictionaryIngredient | undefined
  onEdit: () => void
  onRemove: () => void
  isRemoving: boolean
}

/** Строка корзины: что купили, за сколько и сколько выходит единица. */
const ProductRow = ({
  item,
  ingredient,
  onEdit,
  onRemove,
  isRemoving,
}: ProductRowProps) => {
  const name = ingredient?.name ?? `Продукт №${item.ingredient_id}`
  const unit = ingredient ? quantShort(ingredient.quant) : ''
  const amount = parseDecimal(item.amount)
  const price = parseDecimal(item.price)
  const perUnit = unitPrice(item)

  return (
    <div className="cost-product">
      <div className="cost-product__main">
        <p className="cost-product__name">{name}</p>
        <p className="cost-product__meta">
          {amount === null ? '—' : `${formatAmount(amount)} ${unit}`.trim()}
          {price === null ? '' : ` за ${formatRub(toKopecks(price))}`}
        </p>
        {perUnit !== null && ingredient && (
          <p className="cost-product__unit">
            {perUnit.toLocaleString('ru-RU', { maximumFractionDigits: 4 })} ₽ за
            1 {unit}
          </p>
        )}
        {!ingredient && (
          <p className="cost-product__unit">
            Продукта больше нет в справочнике
          </p>
        )}
      </div>

      <div className="cost-product__actions">
        {ingredient && (
          <button
            type="button"
            onClick={onEdit}
            aria-label={`Изменить ${name}`}
          >
            <Pencil size={18} aria-hidden />
          </button>
        )}
        <button
          type="button"
          onClick={onRemove}
          disabled={isRemoving}
          aria-label={`Убрать ${name}`}
        >
          <Trash2 size={18} aria-hidden />
        </button>
      </div>
    </div>
  )
}

export default ProductRow
